import { IJsonQuery, ERoomType, ESuburbanOfferFilter, TGeoValue } from '@cian/api-models/common/json_query';
import * as R from 'ramda';

import { FDealType, FOfferType } from '../category';
import { setRegionId } from './setRegionId';
import { setDealType } from './setDealType';
import { selectOfferType } from './selectOfferType';
import { setRoomTypes } from './setRoomTypes';
import { setBedroomsCount } from './setBedroomsCount';
import { setPrice } from './setPrice';
import { setMinPrice } from './setMinPrice';
import { setMaxPrice } from './setMaxPrice';
import { setArea } from './setArea';
import { setMinArea } from './setMinArea';
import { setMaxArea } from './setMaxArea';
import { setLandArea } from './setLandArea';
import { setMinLandArea } from './setMinLandArea';
import { setMaxLandArea } from './setMaxLandArea';
import { setPosessor } from './setPosessor';
import { selectGeo } from './selectGeo';
import { clearGeo } from './clearGeo';

export class JsonQuery {
  private jsonQuery: IJsonQuery;

  public constructor(jsonQuery: IJsonQuery) {
    this.jsonQuery = jsonQuery;
  }

  public getSerializable = () => R.clone(this.jsonQuery);

  public setRegion = (region: number[]): this => this.wrap(setRegionId(this.jsonQuery)(region));
  public setDealType = (dealType: FDealType): this => this.wrap(setDealType(this.jsonQuery)(dealType));
  public selectOfferType = (offerType: FOfferType): this => this.wrap(selectOfferType(this.jsonQuery)(offerType));
  public setRoomTypes = (roomTypes: ERoomType[]): this => this.wrap(setRoomTypes(this.jsonQuery)(roomTypes));
  public setBedroomsCount = (gte: number | undefined, lte: number | undefined): this =>
    this.wrap(setBedroomsCount(this.jsonQuery)(gte, lte))
  public setPrice = (gte: number | undefined, lte: number | undefined): this =>
    this.wrap(setPrice(this.jsonQuery)(gte, lte))
  public setMinPrice = (minPrice: number | undefined): this => this.wrap(setMinPrice(this.jsonQuery)(minPrice));
  public setMaxPrice = (maxPrice: number | undefined): this => this.wrap(setMaxPrice(this.jsonQuery)(maxPrice));
  public setArea = (gte: number | undefined, lte: number | undefined): this =>
    this.wrap(setArea(this.jsonQuery)(gte, lte))
  public setMinArea = (minArea: number | undefined): this => this.wrap(setMinArea(this.jsonQuery)(minArea));
  public setMaxArea = (maxArea: number | undefined): this => this.wrap(setMaxArea(this.jsonQuery)(maxArea));
  public setLandArea = (gte: number | undefined, lte: number | undefined): this =>
    this.wrap(setLandArea(this.jsonQuery)(gte, lte))
  public setMinLandArea = (minLandArea: number | undefined): this =>
    this.wrap(setMinLandArea(this.jsonQuery)(minLandArea))
  public setMaxLandArea = (maxLandArea: number | undefined): this =>
    this.wrap(setMaxLandArea(this.jsonQuery)(maxLandArea))
  public setPosessor = (possesor: ESuburbanOfferFilter): this => this.wrap(setPosessor(this.jsonQuery)(possesor));
  public selectGeo = (geoValue: TGeoValue): this => this.wrap(selectGeo(this.jsonQuery)(geoValue));
  public clearGeo = (): this => this.wrap(clearGeo(this.jsonQuery)());

  private wrap = (nextJsonQuery: IJsonQuery) => {
    this.jsonQuery = nextJsonQuery;

    return this;
  }
}
